import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AbsenSholat = () => {
  const [asramaList, setAsramaList] = useState([]);
  const [selectedAsrama, setSelectedAsrama] = useState('');
  const [tanggal, setTanggal] = useState(new Date().toISOString().split('T')[0]);
  const [waktuSholat, setWaktuSholat] = useState('Subuh');
  
  const [siswaList, setSiswaList] = useState([]);
  const [absensi, setAbsensi] = useState({}); // { siswa_id: 'Hadir' | 'Izin' | 'Sakit' | 'Alpha' }
  const [loading, setLoading] = useState(false);

  const API_URL = 'http://localhost:10000/api'; // Sesuaikan IP VPS / URL API kamu

  useEffect(() => {
    fetchAsrama();
  }, []);

  useEffect(() => {
    if (selectedAsrama) {
      fetchSiswaAndAbsensi();
    }
  }, [selectedAsrama, tanggal, waktuSholat]);

  const fetchAsrama = async () => {
    try {
      const res = await axios.get(`${API_URL}/asrama`);
      setAsramaList(res.data);
      if (res.data.length > 0) setSelectedAsrama(res.data[0].id);
    } catch (err) { console.error(err); }
  };

  const fetchSiswaAndAbsensi = async () => {
    setLoading(true);
    try {
      // 1. Ambil daftar anggota asrama
      const resSiswa = await axios.get(`${API_URL}/asrama/${selectedAsrama}/anggota`);
      setSiswaList(resSiswa.data);

      // 2. Ambil data absensi yang sudah tersimpan (jika ada)
      const resAbsen = await axios.get(`${API_URL}/absensi-sholat`, {
        params: { asrama_id: selectedAsrama, tanggal, waktu_sholat: waktuSholat }
      });

      // Mapping data absensi
      const initialMap = {};
      resSiswa.data.forEach(s => {
        initialMap[s.id] = 'Hadir'; // Default Hadir
      });

      if (resAbsen.data && resAbsen.data.length > 0) {
        resAbsen.data.forEach(item => {
          initialMap[item.siswa_id] = item.status;
        });
      }

      setAbsensi(initialMap);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (siswaId, status) => {
    setAbsensi(prev => ({ ...prev, [siswaId]: status }));
  };

  const handleSimpan = async () => {
    if (!selectedAsrama) return alert('Pilih asrama terlebih dahulu');
    try {
      const payload = {
        asrama_id: selectedAsrama,
        tanggal,
        waktu_sholat: waktuSholat,
        absensi: Object.keys(absensi).map(siswaId => ({
          siswa_id: parseInt(siswaId),
          status: absensi[siswaId]
        }))
      };

      await axios.post(`${API_URL}/absensi-sholat`, payload);
      alert('Absensi sholat berhasil disimpan!');
    } catch (err) {
      alert('Gagal menyimpan absensi sholat');
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>🕌 Absensi Sholat Asrama</h2>
      
      {/* Filter / Form Header */}
      <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '5px' }}>Asrama:</label>
          <select value={selectedAsrama} onChange={(e) => setSelectedAsrama(e.target.value)} style={{ padding: '8px' }}>
            {asramaList.map(a => (
              <option key={a.id} value={a.id}>{a.nama_asrama}</option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '5px' }}>Tanggal:</label>
          <input type="date" value={tanggal} onChange={(e) => setTanggal(e.target.value)} style={{ padding: '8px' }} />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '5px' }}>Waktu Sholat:</label>
          <select value={waktuSholat} onChange={(e) => setWaktuSholat(e.target.value)} style={{ padding: '8px' }}>
            <option value="Subuh">Subuh</option>
            <option value="Dzuhur">Dzuhur</option>
            <option value="Ashar">Ashar</option>
            <option value="Maghrib">Maghrib</option>
            <option value="Isya">Isya</option>
          </select>
        </div>
      </div>

      {loading ? (
        <p>Memuat data siswa...</p>
      ) : (
        <>
          <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
            <thead>
              <tr style={{ background: '#f4f4f4' }}>
                <th>No</th>
                <th>Nama Siswa</th>
                <th>Kelas</th>
                <th>Status Kehadiran</th>
              </tr>
            </thead>
            <tbody>
              {siswaList.length > 0 ? (
                siswaList.map((siswa, idx) => (
                  <tr key={siswa.id}>
                    <td>{idx + 1}</td>
                    <td>{siswa.nama}</td>
                    <td>{siswa.kelas}</td>
                    <td>
                      {['Hadir', 'Izin', 'Sakit', 'Alpha'].map(status => (
                        <label key={status} style={{ marginRight: '15px', cursor: 'pointer' }}>
                          <input
                            type="radio"
                            name={`status-${siswa.id}`}
                            value={status}
                            checked={absensi[siswa.id] === status}
                            onChange={() => handleStatusChange(siswa.id, status)}
                          />
                          {status}
                        </label>
                      ))}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center' }}>Belum ada anggota di asrama ini.</td>
                </tr>
              )}
            </tbody>
          </table>

          {siswaList.length > 0 && (
            <button onClick={handleSimpan} style={{ marginTop: '20px', padding: '10px 20px', cursor: 'pointer' }}>
              💾 Simpan Absensi
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default AbsenSholat;